import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=89795b20&scoped=true&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&id=89795b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89795b20",
  null
  
)

export default component.exports